import { DateFormatType, formatDate } from "~/utils/datetime"

// A buy from selected Triggers rows is placed today and covers until the next buy, the window the
// Overview scores those rows over.
export const isScopedBuy = (scopedVariantIds: readonly string[] | undefined): boolean =>
  scopedVariantIds !== undefined && scopedVariantIds.length > 0

// Dated today, matching Overview's simulated buy, not the plan's next buy date.
export function getCreateBuyDefaults(
  isScoped: boolean,
  today: Date,
): { name: string; buyDate: Date } {
  const date = formatDate(today, DateFormatType.DefaultYearFirst)
  return { name: isScoped ? `Immediate replenishment ${date}` : `Buy ${date}`, buyDate: today }
}

// Only the Triggers warehouse when one is picked, so the buy writes what the row showed.
export function initialDeselectedWarehouseIds(
  warehouseIds: readonly string[],
  defaultWarehouseId: string | undefined,
): Set<string> {
  if (!defaultWarehouseId || !warehouseIds.includes(defaultWarehouseId)) return new Set()
  return new Set(warehouseIds.filter((id) => id !== defaultWarehouseId))
}
